import React, { FC, useState } from 'react';
import styled from 'styled-components';

import Burger from '@ui/atoms/Burger';
import FolxLogo from '@ui/atoms/FolxLogo';

import FolxHeader from '@ui/molecules/FolxHeader';
import NavRow from '@ui/molecules/NavRow/NavRow.component';

import MobileDashboardNav from '@ui/organisms/MobileDashboardNav';

import useWindowSize from '@hooks/useWindowSize';

import { INavItem } from '@folx-types/dashboard';

import theme from '@theme/FolxTheme';

interface IDashboardHeaderProps {
	currentPath?: string;
	navItems?: INavItem[];
}

const ProfileMenu = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: ${theme.spacing.lg};
`;

const DashboardHeader: FC<IDashboardHeaderProps> = ({ currentPath = '', navItems = [] }) => {
	const [navOpen, setNavOpen] = useState(false);
	const { isTablet } = useWindowSize();

	const burger = (
		<Burger
			active={navOpen}
			onClick={() => {
				setNavOpen(!navOpen);
			}}
		/>
	);

	const navMenu = <NavRow currentPath={location?.pathname} items={navItems} />;
	const profileMenu = <ProfileMenu>{navMenu}</ProfileMenu>;

	return (
		<FolxHeader
			sticky
			centerContent={isTablet && <FolxLogo />}
			leftContent={isTablet ? burger : <FolxLogo />}
			rightContent={!isTablet && profileMenu}
			bottomContent={
				<MobileDashboardNav
					navItems={navItems}
					navOpen={navOpen}
					navClicked={() => setNavOpen(false)}
				/>
			}
		/>
	);
};

export default DashboardHeader;
